import {
  useFetchSupportArticles,
  useArticleNavigation as useArticleNavigationCore,
} from "@core/features/support";

export type Args = {
  articleId: string | null;
};

/**
 * Platform-specific wrapper for useArticleNavigation.
 * Automatically fetches categories from useFetchSupportArticles.
 */
export function useArticleNavigation({ articleId }: Args) {
  const { data } = useFetchSupportArticles();
  const categories = data?.categories ?? [];

  return useArticleNavigationCore({ articleId, categories });
}

export default useArticleNavigation;

